import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import AddEditProduct from "../AddEditProduct/AddEditProduct";
import { ProductsListContainer, MainTitle } from "./ProductsList.styled";

import "./ProductsList.scss";

/**
 * Product List,
 * Path - /products
 * @see See [products Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2881060894/Analytical+notes+form)
 * @component
 */
const ProductsList = (props) => {
  const { t, columnList, categories, countries, subCategories } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddProductPopupVisible, setAddProductPopupVisible] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const createProduct = () => {
    setAddProductPopupVisible(true);
  };
  const closeSolutionCreationPopup = () => {
    setAddProductPopupVisible(false);
  };

  return (
    <ProductsListContainer className="analytical-notes-list">
      <MainTitle>{t("PRODUCTS")}</MainTitle>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        createProduct={createProduct}
        categories={categories}
        subCategories={subCategories}
        countries={countries}
      />
      {isAddProductPopupVisible && (
        <AddEditProduct
          title={t("PRODUCT")}
          onClose={closeSolutionCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          countries={countries}
        />
      )}
    </ProductsListContainer>
  );
};

ProductsList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ProductsList);
